/**
 * @fileoverview Defines the `Contact` React component, which renders contact links. It includes links for email, Github, a blog, privacy policy, and bug reports using `<a>` tags. The component is exported as the default export.
 */

import React from 'react'
import '../styles/components/Contact.css'

const Contact = () => {
  return (
    <div className="contact">
      <a href="mailto:hello@ref.tools" className="link">
        hello@ref.tools
      </a>

      <a
        href="https://github.com/ref-tools/ref-tools-mcp"
        className="link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Github
      </a>

      <a href="/privacy" className="link">
        Privacy
      </a>

      <a href="/status" className="link">
        Status
      </a>

      <a href="https://tally.so/r/wQW0x8" className="link" target="_blank">
        Report a bug
      </a>

      <a href="https://tally.so/r/nrvBY2" className="link" target="_blank">
        Add missing docs
      </a>
    </div>
  )
}

export default Contact
